// The full Entity Identifier Code list (DE 98) — shared by every N101 and
// N101-shaped qualifier element across transaction sets. Union of the
// previous hand-picked N1 N101 subset (header-segments.ts) and the
// 856-specific N101 list in
// reference/session/856-ship-notice-manifest-qualifiers-txt.md.

import type {CodeListEntry} from './types';

export const ENTITY_IDENTIFIER_CODES: CodeListEntry[] = [
  {code: 'ST', label: 'Ship To'},
  {code: 'BT', label: 'Bill To'},
  {code: 'BY', label: 'Buying Party (Purchaser)'},
  {code: 'SE', label: 'Selling Party'},
  {code: 'VN', label: 'Vendor'},
  {code: 'SF', label: 'Ship From'},
  {code: 'RE', label: 'Payee'},
  {code: 'BS', label: 'Bill and Ship To'},
  {code: 'OB', label: 'Ordered By'},
  {code: 'SU', label: 'Supplier/Manufacturer'},
  {code: 'Z7', label: 'Mark-for Party'},
  {code: 'MA', label: 'Party for whom Item is Ultimately Intended'},
  {code: 'EN', label: 'End User'},
  {code: 'DA', label: 'Delivery Address'},
  {code: 'CA', label: 'Carrier'},
  {code: 'WH', label: 'Warehouse'},
  {code: 'RI', label: 'Remit To'},
  {code: 'II', label: 'Issuer of Invoice'},
  {code: 'SO', label: 'Sold To If Different From Bill To'},
  {code: 'DS', label: 'Distributor'},
  {code: 'DB', label: 'Distributor Branch'},
  {code: 'MF', label: 'Manufacturer of Goods'},
  {code: 'LW', label: 'Customer'},
  {code: 'IA', label: 'Installed At'},
  {code: 'SH', label: 'Shipper'},
  {code: 'CN', label: 'Consignee'},
  {code: 'PF', label: 'Party to Receive Freight Bill'},
];
